import { UntypedFormGroup } from '@angular/forms';
import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';
import { LoginHeaderContent } from '../../../shared/login-header/models/login-header.interface';

export interface RecoveryOptionsContent {
  formGroup: UntypedFormGroup;
  pageContent: RecoveryOptionsPageContent;
  hasError: boolean;
  errorMessage: string;
  disabledActionButton: boolean;
}

export interface RecoveryOptionsPageContent {
  pageHeader: LoginHeaderContent;
  nextDisplayView: NextDisplayView;
  emailLabel: string;
  sqaLabel: string;
  emailText: string;
  sqaText: string;
  buttonLabel: string;
  viewName: string;
}
